var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('query-list',{attrs:{"columnsFormatData":_vm.columnsFormatData,"askData":_vm.askData,"refreshData":_vm.update_count,"uri_name":"/auth_interface","main_width":"1230","withOption":false}})}
var staticRenderFns = []

export { render, staticRenderFns }